// Shared constants for the Admin V2 "Planes y Accesos" module (mockup phase).
export const BILLING_TYPES = [
  { value: "per_listing", label: "Por aviso" },
  { value: "daily", label: "Por día" },
  { value: "weekly", label: "Por semana" },
  { value: "monthly", label: "Por mes" },
  { value: "yearly", label: "Por año" },
  { value: "trial", label: "Trial" },
  { value: "manual", label: "Acceso manual" },
  { value: "custom", label: "Otro / Personalizado" },
];

export const DURATION_UNITS = [
  { value: "day", label: "Día(s)" },
  { value: "week", label: "Semana(s)" },
  { value: "month", label: "Mes(es)" },
  { value: "year", label: "Año(s)" },
  { value: "unlimited", label: "Sin vencimiento" },
];

export const RENEWAL_OPTIONS = [
  { value: "automatic", label: "Automática" },
  { value: "manual", label: "Manual" },
  { value: "not_applicable", label: "No aplica" },
];

export const LISTINGS_MODES = [
  { value: "custom", label: "Número personalizado" },
  { value: "unlimited", label: "Ilimitados" },
  { value: "not_applicable", label: "No aplica" },
];

// Preloaded, extensible — never hardcode logic that blocks adding a new one later.
export const CURRENCIES = [
  { code: "EUR", symbol: "€" },
  { code: "USD", symbol: "US$" },
  { code: "UYU", symbol: "$U" },
  { code: "ARS", symbol: "AR$" },
  { code: "BRL", symbol: "R$" },
];

export function billingLabel(value) {
  return BILLING_TYPES.find((b) => b.value === value)?.label || value;
}
export function durationLabel(amount, unit) {
  if (unit === "unlimited") return "Sin vencimiento";
  const u = DURATION_UNITS.find((d) => d.value === unit)?.label || unit;
  return `${amount || 1} ${u}`;
}
export function listingsLabel(mode, amount) {
  if (mode === "unlimited") return "Ilimitados";
  if (mode === "not_applicable") return "No aplica";
  return `${amount ?? 0} aviso(s)`;
}
export function priceLabel(plan) {
  const symbol = CURRENCIES.find((c) => c.code === plan.price_currency)?.symbol || plan.price_currency || "";
  if (plan.billing_type === "trial") return "Gratis (trial)";
  if (plan.billing_type === "manual") return "Sin precio (manual)";
  if (plan.price_amount == null) return "A definir";
  const perUnit = { per_listing: "/aviso", daily: "/día", weekly: "/sem.", monthly: "/mes", yearly: "/año" }[plan.billing_type] || "";
  return `${symbol}${plan.price_amount}${perUnit}`;
}
